export default __webpack_public_path__ + "static/defi-safety-logo-3e18ebfb4127d0c2dfa9abf79bdd4582.png";